import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ForgetPassword } from 'src/app/shared/models/login.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService {

  constructor(
    private http: HttpClient
  ) { }

  changePassword(email) {
    let data = {
      EMAIL: email
    }
    return this.http.post<ForgetPassword>(environment.URL + '/authen/ForgetPassword', data);
  }
}

